import { useQuery } from '@tanstack/react-query';

import type { MeDataType } from '@/types';

import axiosInstance from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

const useGetMe = () =>
  useQuery<MeDataType>({
    queryKey: ['me'],
    queryFn: async () => {
      const response = await axiosInstance.get(API_ROUTES.auth.me);

      return response.data;
    },
    retry: false,
  });

export default useGetMe;
